import { Subject, Observable } from 'rxjs';
export default function createIntentSubject$() {
  var observer;
  var source = Observable.create(function (obs) {
    observer = obs;
  });
  var destination = {
    next: function next(n) {
      return observer.next(n);
    },
    complete: function complete() {
      return observer.complete();
    },
    error: function error(e) {
      return observer.error(e);
    }
  };
  return Subject.create(destination, source);
}